import { ReactNode } from 'react';
import { ErrorsNotificationInHeader } from '@providers/ErrorsNotificationProvider';

import { cx } from '@libs/classnames';
import { ColoredBackground } from '@ui/components/ColoredBackground';
import { Layout } from '@ui/components/Layout/Layout';

import { useClubColors } from '@features/club/hooks/useClubColors';
import { Copyright } from '@features/shared/ui/Copyright';
import { SiteHeader } from '@features/shared/ui/SiteHeader';
import { SiteLogo } from '@features/shared/ui/SiteLogo';

import styles from './SiteLayout.module.css';

export type Props = {
  className?: string;
  rootClassName?: string;
  themeColor?: string | null;
  children: ReactNode;
  siteLogo?: ReactNode;
  centeredTitle?: ReactNode;
  actions?: ReactNode;
  preset?: 'default' | 'landing' | 'default-full-width';
  backgroundPreset?: 'coloured' | 'plain' | 'coloured-promo-gradient' | 'coloured-red-dawn';
};
export function SiteLayout({
  className,
  rootClassName,
  themeColor,
  centeredTitle,
  siteLogo,
  actions,
  preset = 'default',
  backgroundPreset = 'coloured',
  children,
}: Props) {
  // перекраска в клубные цвета
  useClubColors(themeColor);

  return (
    <Layout
      className={cx(
        styles.layout,
        styles[backgroundPreset],
        styles[`preset_${preset}`],
        rootClassName,
        {
          'theme-light': preset === 'landing',
        },
      )}
      header={
        <SiteHeader
          className={cx(styles.header, {
            'theme-dark': preset === 'landing',
          })}
          siteLogo={siteLogo ?? <SiteLogo variant="chessopen-play" />}
          centeredTitle={centeredTitle}
          actions={actions}
        />
      }
    >
      <div className={cx(styles.innerContainer, className)}>
        {backgroundPreset === 'coloured' && <ColoredBackground />}
        <div className={styles.content}>
          <div className={styles.innerContent}>{children}</div>

          <div className={styles.footer}>
            <Copyright />
          </div>
        </div>
      </div>
      <ErrorsNotificationInHeader />
    </Layout>
  );
}
